import React from 'react';
import { Link } from 'react-router-dom';

//Navigate from page to page
function Nav() {
  return (
    <nav className="App-nav">
        <Link to="/">Home</Link>
        <Link to="../about">About Us</Link>
        <Link to="../blog">Blog</Link>
        <Link to="../contact">Contact</Link>
        <Link to="../calendar">Calendar</Link>
        <Link to="../forum">Forum</Link>
    </nav>
  );
}

export default Nav;
